import React, { useEffect, useState } from 'react'
import { Segmented,Form,Input,Button,Select,Space, Tooltip, message } from 'antd'
import './style.css'
import { PlusCircleOutlined } from '@ant-design/icons'
import { TbTrashFilled } from 'react-icons/tb'
import axios from 'axios'
import { SERVER_ADDRESS } from '../../Config/Config'

const AddEducationDetails = () => {
  const [selectedOption,setSelectedOption] = useState('Education Level')
  const [education,setEducation] = useState([])
  const [degree,setDegree] = useState([])
  const [form] = Form.useForm();
  const [degreeform] = Form.useForm();
  const [subjectform] = Form.useForm();
  const options = ['Education Level','Degree','Subject']

  const fetchEducation = async()=>{
        try {
          const response = await axios.post(`${SERVER_ADDRESS}/api/getEducationDetails`,{flag:1});
          if(response.status === 200 && response.data.result === 1){
            const options = response.data.data.map((item)=>({
              label:item.education_level,
              value:item.id
            }))
            setEducation(options)
          }
        } catch (error) {
          message.error({content:"Something Went Wrong !"})
        }
      }
  
      const fetchDegree = async(education_id)=>{
        try {
          const response = await axios.post(`${SERVER_ADDRESS}/api/getEducationDetails`,{flag:2,education_id});
          if(response.status === 200 && response.data.result === 1){
            const options = response.data.data.map((item)=>({
              label:item.degree,
              value:item.id
            }))
            setDegree(options)
          }
        } catch (error) {
          message.error({content:"Something Went Wrong !"})
        }
      }

      const handleEducationChange = (education_level_id)=>{
        fetchDegree(education_level_id)
      }

      useEffect(()=>{
        fetchEducation()
      },[selectedOption])

      const handleEducation = async(values)=>{
        const fieldKey = selectedOption.toLowerCase().replace(/\s+/g, '_'); // Convert to match form name
        const data = values[selectedOption.toLowerCase()].map((item) => {
            return {
                [fieldKey]: item[fieldKey], // Ensure correct key is accessed
            };
        });
        
          try {
              const response = await axios.post(`${SERVER_ADDRESS}/api/addEducation`,{type:1,data})
              if(response.status === 200 && response.data.result === 1 ){
                  message.success({content:`${response.data.message}`})
                  form.resetFields()
              }
          } catch (error) {
              message.error({content:"Something Went Wrong !"})
          }
      }
  
      const handleDegree = async(values)=>{
        try {
          const response = await axios.post(`${SERVER_ADDRESS}/api/addEducation`,{type:2,data:values})
          if(response.status === 200 && response.data.result === 1 ){
            message.success({content:`${response.data.message}`})
            degreeform.resetFields();
            degreeform.setFieldsValue({ degree: [{}] });
          }
          if(response.data.result===0){
            message.warning({content:`${response.data.message}`})
          }
        } catch (error) {
          message.error({content:"Somthing went wrong !"})
        }
      }
  
      const handleSubject = async(values)=>{
        try {
          const response = await axios.post(`${SERVER_ADDRESS}/api/addEducation`,{type:3,data:values})
          if(response.status === 200 && response.data.result === 1 ){
            message.success({content:`${response.data.message}`})
            subjectform.resetFields();
            subjectform.setFieldsValue({ subject: [{}] });
          }
          if(response.data.result===0){
            message.warning({content:`${response.data.message}`})
          }
        } catch (error) {
          message.error({content:"Somthing went wrong !"})
        }
      }

      const renderForm = ()=>{
              switch (selectedOption) {
                  case 'Education Level':
                     return (
                      <Form form={form} onFinish={handleEducation} autoComplete="off" initialValues={{ [selectedOption.toLowerCase()]: [{}] }}>
                      <Form.List name={selectedOption.toLowerCase()}>
                        {(fields, { add, remove }) => (
                          <>
                            {fields.map(({ key, name, ...restField }, index) => (
                              <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                                <Form.Item label='Education Level' 
                                  {...restField}
                                  name={[name, 'education_level']}
                                  rules={[{ required: true, message: `Enter ${selectedOption} Name` }]}
                                >
                                  <Input placeholder={`Enter ${selectedOption}`} style={{width:"30rem"}} />
                                </Form.Item>
                                {fields.length > 1 && (
                                  <Tooltip title='Remove Row' >
                                      <Button color="danger" variant='filled' onClick={() => remove(name)}>
                                          <TbTrashFilled />
                                      </Button>
                                  </Tooltip>
                                )}
                              </Space>
                            ))}
                            <Form.Item wrapperCol={{offset:2}} >
                            <Tooltip title='Add Row' >
                              <Button style={{width:'4rem'}} variant="solid" color='blue' onClick={() =>  add({ [selectedOption.toLowerCase()]: '', code: '' })} block>
                                  <PlusCircleOutlined />
                              </Button>
                            </Tooltip>
                            </Form.Item>
                          </>
                        )}
                      </Form.List>
              
                      <Form.Item wrapperCol={{offset:6}} >
                        <Button type="primary" htmlType="submit">
                          Submit {selectedOption}
                        </Button>
                      </Form.Item>
                      </Form>
                      )
                  case 'Degree':
                      return (
                        <Form form={degreeform} onFinish={handleDegree} autoComplete="off" initialValues={{ [selectedOption.toLowerCase()]: [{}] }}>
                          <Form.Item label='Education' name='education_level_id' rules={[{required:true,message:"Select Education"}]} style={{width:"33.2rem"}} >
                                <Select
                                showSearch
                                  placeholder="Select a Education"
                                  options={education}
                                  optionFilterProp="label"
                                  filterSort={(a,b)=>(a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}
                                />
                                  </Form.Item>
                        <Form.List name={selectedOption.toLowerCase()}>
                          {(fields, { add, remove }) => (
                            <>
                              {fields.map(({ key, name, ...restField }, index) => (
                                <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                                  <Form.Item  wrapperCol={{offset:1}} label='State' 
                                    {...restField}
                                    name={[name, 'degree']}
                                    rules={[{ required: true, message: `Enter ${selectedOption} Name` }]}
                                  >
                                    <Input placeholder={`Enter ${selectedOption}`} style={{width:"30rem"}} />
                                  </Form.Item>
                                  {fields.length > 1 && (
                                    <Tooltip title='Remove Row' >
                                        <Button style={{marginLeft:"1.3rem"}} color="danger" variant='filled' onClick={() => remove(name)}>
                                            <TbTrashFilled />
                                        </Button>
                                    </Tooltip>
                                  )}
                                </Space>
                              ))}
                              <Form.Item wrapperCol={{offset:2}} >
                              <Tooltip title='Add Row' >
                                <Button style={{width:'4rem'}} variant="solid" color='blue' onClick={() => add({})} block>
                                    <PlusCircleOutlined />
                                </Button>
                              </Tooltip>
                              </Form.Item>
                            </>
                          )}
                        </Form.List>
                
                        <Form.Item wrapperCol={{offset:6}} >
                          <Button type="primary" htmlType="submit">
                            Submit {selectedOption}
                          </Button>
                        </Form.Item>
                        </Form>
                      )
                  case 'Subject':
                      return (
                        <Form form={subjectform} onFinish={handleSubject} autoComplete="off" initialValues={{ [selectedOption.toLowerCase()]: [{}] }}>
                        <Form.Item label='Education Level' name='education_level_id_1' labelCol={{offset:3}} rules={[{required:true,message:"Select Education Level"}]} style={{width:"33.2rem"}} >
                              <Select
                              showSearch
                              onChange={(value)=>{
                                handleEducationChange(value)
                              }}
                                placeholder="Select a Education Level"
                                options={education}
                                optionFilterProp="label"
                                filterSort={(a,b)=>(a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}
                              />
                          </Form.Item>
                          <Form.Item label='Degree' name='degree_id' labelCol={{offset:3}} rules={[{required:true,message:"Select Country"}]} style={{width:"33.2rem"}} >
                              <Select
                              showSearch
                                placeholder="Select a Degree"
                                options={degree}
                                optionFilterProp="label"
                                filterSort={(a,b)=>(a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}
                              />
                          </Form.Item>
                      <Form.List name={selectedOption.toLowerCase()}>
                        {(fields, { add, remove }) => (
                          <>
                            {fields.map(({ key, name, ...restField }, index) => (
                              <Space key={key} style={{ display: 'flex',flexDirection:"row",gap:"4rem" ,marginBottom: 8 }} align="baseline">
                                <Form.Item labelCol={{offset:3}} label='Subject' 
                                  {...restField}
                                  name={[name, 'subject']}
                                  rules={[{ required: true, message: `Enter ${selectedOption} Name` }]}
                                >
                                  <Input placeholder={`Enter ${selectedOption}`} style={{width:"30rem"}} />
                                </Form.Item>
                                {fields.length > 1 && (
                                  <Tooltip title='Remove Row' >
                                      <Button style={{marginLeft:"1.3rem"}} color="danger" variant='filled' onClick={() => remove(name)}>
                                          <TbTrashFilled />
                                      </Button>
                                  </Tooltip>
                                )}
                              </Space>
                            ))}
                            <Form.Item wrapperCol={{offset:2}} >
                            <Tooltip title='Add Row' >
                              <Button style={{width:'4rem'}} variant="solid" color='blue' onClick={() => add({})} block>
                                  <PlusCircleOutlined />
                              </Button>
                            </Tooltip>
                            </Form.Item>
                          </>
                        )}
                      </Form.List>
              
                      <Form.Item wrapperCol={{offset:6}} >
                        <Button type="primary" htmlType="submit">
                          Submit {selectedOption}
                        </Button>
                      </Form.Item>
                      </Form>
                      )
                  default:
                      break;
              }
          }

  return (
    <div style={{marginTop:'4rem'}} >
            <Segmented color='' options={options} block selected={selectedOption} onChange={setSelectedOption} />
            <div className='mt-3 p-4' style={{backgroundColor:"white",borderRadius:"1rem"}}  >
              <h3 className='py-4' >{selectedOption} Form</h3>
                {renderForm()}
            </div>
        </div>
  )
}

export default AddEducationDetails